const link = process.env.REACT_APP_SERVER_API_V2
const getPasswordResetUrl = () => `${link}/reset-password`

export default getPasswordResetUrl;
